/**
 * PLP + PDP: sincroniza badges Best Seller / Limited con swatches de color y variantes.
 * Depende de theme.js (ProductCard / ProductMain) y del markup en product-card.liquid + product__main.liquid.
 */
(function () {
  const PLP = {
    swatch: "[js-swatch]",
    swatchImage: "[js-swatch-image]",
    badgeBestSeller: "[js-badge-best-seller]",
    badgeLimitedQuantities: "[js-badge-limited-quantities]",
  };

  const PDP = {
    colorSwatchWrap: "[js-pdp-color-swatches]",
    colorSwatchLink: "a.product__swatch[js-pdp-swatch-link]",
    badgeBestSeller: "[js-pdp-badge-best-seller]",
    badgeLimitedQuantities: "[js-pdp-badge-limited-quantities]",
    variantBadgeMap: "#ProductVariantBadgeMap",
  };

  function syncPlpBadgesFromSwatchImage(card, imageEl) {
    const badgeBestSeller = card.querySelector(PLP.badgeBestSeller);
    const badgeLimited = card.querySelector(PLP.badgeLimitedQuantities);
    if (!badgeBestSeller && !badgeLimited) return;

    let showBest;
    let showLimited;
    let label;
    if (imageEl) {
      showBest = imageEl.dataset.badgeBestSeller === "1";
      showLimited = imageEl.dataset.badgeLimitedQuantities === "1";
      label = imageEl.dataset.badgeLimitedLabel || "";
    } else {
      showBest = false;
      showLimited = false;
      label = "";
    }
    if (badgeBestSeller) badgeBestSeller.classList.toggle("hidden", !showBest);
    if (badgeLimited) {
      badgeLimited.classList.toggle("hidden", !showLimited);
      badgeLimited.textContent = label;
    }
  }

  function syncPlpBadgesFromActiveSwatchImage(card) {
    const img =
      card.querySelector(`${PLP.swatchImage}.active`) || card.querySelector(`${PLP.swatchImage}.active--first`);
    syncPlpBadgesFromSwatchImage(card, img);
  }

  function wireProductCardBadgeSync(card) {
    if (card.dataset.productBadgeSyncWired === "true") return;
    if (!card.querySelector(PLP.swatchImage)) return;
    card.dataset.productBadgeSyncWired = "true";

    const onSwatchInteraction = () => {
      syncPlpBadgesFromActiveSwatchImage(card);
    };

    card.querySelectorAll(PLP.swatch).forEach((swatch) => {
      swatch.addEventListener("mouseover", onSwatchInteraction);
      swatch.addEventListener("mouseout", onSwatchInteraction);
      swatch.addEventListener("focus", onSwatchInteraction);
      swatch.addEventListener("blur", onSwatchInteraction);
      swatch.addEventListener("click", onSwatchInteraction);
    });

    syncPlpBadgesFromActiveSwatchImage(card);
  }

  function patchProductCardConnectedCallback() {
    const ProductCard = customElements.get("product-card");
    if (!ProductCard || ProductCard.prototype.__productBadgeSyncConnectedPatched) return;
    ProductCard.prototype.__productBadgeSyncConnectedPatched = true;

    const original = ProductCard.prototype.connectedCallback;
    ProductCard.prototype.connectedCallback = function () {
      original.call(this);
      wireProductCardBadgeSync(this);
    };
  }

  function applyPdpBadgesFromData(host, badgeBestSeller, badgeLimited, row) {
    const showBest = !!row.best;
    const showLimited = !!row.limited;
    const label = row.label || "";
    if (badgeBestSeller) badgeBestSeller.classList.toggle("hidden", !showBest);
    if (badgeLimited) {
      badgeLimited.classList.toggle("hidden", !showLimited);
      badgeLimited.textContent = label;
    }
  }

  function initPdpBadgeSync(host) {
    if (host.dataset.pdpBadgeSyncInit === "true") return;
    const badgeBestSeller = host.querySelector(PDP.badgeBestSeller);
    const badgeLimited = host.querySelector(PDP.badgeLimitedQuantities);
    if (!badgeBestSeller && !badgeLimited) return;

    host.dataset.pdpBadgeSyncInit = "true";

    const variantBadgeMapEl = host.querySelector(PDP.variantBadgeMap);
    let variantBadgeMap = {};
    try {
      variantBadgeMap = variantBadgeMapEl ? JSON.parse(variantBadgeMapEl.textContent || "{}") : {};
    } catch (e) {
      variantBadgeMap = {};
    }

    const colorWrap = host.querySelector(PDP.colorSwatchWrap);

    const applyFromSwatchLink = (link) => {
      if (!link) {
        applyPdpBadgesFromData(host, badgeBestSeller, badgeLimited, { best: 0, limited: 0, label: "" });
        return;
      }
      applyPdpBadgesFromData(host, badgeBestSeller, badgeLimited, {
        best: link.dataset.badgeBestSeller === "1" ? 1 : 0,
        limited: link.dataset.badgeLimitedQuantities === "1" ? 1 : 0,
        label: link.dataset.badgeLimitedLabel || "",
      });
    };

    const applyFromActiveColorSwatch = () => {
      const active = colorWrap && colorWrap.querySelector(`${PDP.colorSwatchLink}.active`);
      if (active) applyFromSwatchLink(active);
    };

    if (colorWrap) {
      colorWrap.addEventListener("mouseleave", applyFromActiveColorSwatch);
      colorWrap.addEventListener("focusout", (event) => {
        if (colorWrap && event.relatedTarget instanceof Node && !colorWrap.contains(event.relatedTarget)) {
          applyFromActiveColorSwatch();
        }
      });
      colorWrap.querySelectorAll(PDP.colorSwatchLink).forEach((link) => {
        link.addEventListener("mouseenter", () => applyFromSwatchLink(link));
        link.addEventListener("focusin", () => applyFromSwatchLink(link));
      });
    }

    host.addEventListener("variant:change", (event) => {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;
      const row = variantBadgeMap[String(variant.id)];
      if (row) applyPdpBadgesFromData(host, badgeBestSeller, badgeLimited, row);
    });
  }

  function patchProductMainConnectedCallback() {
    const ProductMain = customElements.get("s-product");
    if (!ProductMain || ProductMain.prototype.__pdpBadgeSyncConnectedPatched) return;
    ProductMain.prototype.__pdpBadgeSyncConnectedPatched = true;

    const original = ProductMain.prototype.connectedCallback;
    ProductMain.prototype.connectedCallback = function () {
      original.call(this);
      initPdpBadgeSync(this);
    };
  }

  function bootstrap() {
    patchProductCardConnectedCallback();
    patchProductMainConnectedCallback();

    document.querySelectorAll("product-card").forEach((card) => {
      wireProductCardBadgeSync(card);
    });

    document.querySelectorAll("s-product").forEach((host) => {
      initPdpBadgeSync(host);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap);
  } else {
    bootstrap();
  }
})();
